import React from 'react';

const Effect = ({currentEffects=[], updateCreatureEffects=[], effectName, image, type}) => {
    const hasEffect = currentEffects.some(e => e.effectName === effectName);
    const matchingEffect = currentEffects.find(e => e.effectName === effectName);

    return (
        <div className='effectWrapper' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }} onClick={(event) => updateCreatureEffects(event, effectName, type)}>
            <img className='effect'
                src={image}
                alt={effectName}
                style={{ 
                    opacity: hasEffect ? 0.3 : 1, 
                    outline: hasEffect ? '2px solid #ffffff' : '',
                    borderRadius: '100%',
                }}
            />
            {matchingEffect?.duration && (
                <span style={{ position: 'absolute', right: '10%', fontSize: '1em', color: 'white', fontWeight: 'bold' }}>
                    {matchingEffect?.duration}
                </span>
            )}
            <span style={{color: "white", fontSize: "0.75rem", textAlign: "center"}}>{effectName.replace("Condition", "")}</span>
        </div>
    );
};

export default Effect;